<template>
  <div class="page-wrapper compact-wrapper dark-sidebar" id="pageWrapper">
    <header1 />
    <div class="page-body-wrapper">
      <sidebar1 />
      <div class="page-body">
        <div class="container-fluid">
          <titleHeader1 v-if="breadcrumbs.type === 1" :breadcrumbs="breadcrumbs" />
          <titleHeader2 v-if="breadcrumbs.type === 2" :breadcrumbs="breadcrumbs" />
          <titleHeader3 v-if="breadcrumbs.type === 3" :breadcrumbs="breadcrumbs" />
          <slot></slot>
        </div>
        <footer1 />
      </div>
    </div>
    <div class="customizer-links" @click.prevent="toggleDirection">
      <button class="rtl-btn" :class="direction == 'rtl' ? 'rtl' : ''">
        {{ direction == 'ltr' ? 'RTL' : 'LTR' }}
      </button>
    </div>
    <div class="bg-overlay active" v-if="overlay" @click.prevent="closeOverlay"></div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue';
import { useClickStore } from '@/store/clickEvents';
import footer1 from '@/layouts/common/footer/footer1.vue';
import header1 from '@/layouts/common/header/header1.vue';
import sidebar1 from '@/layouts/common/sidebar/sidebar1.vue';
import titleHeader1 from '@/layouts/common/titleHeaders/titleHeader1.vue';
import titleHeader2 from '@/layouts/common/titleHeaders/titleHeader2.vue';
import titleHeader3 from '@/layouts/common/titleHeaders/titleHeader3.vue';
import { storeToRefs } from 'pinia';

defineProps({
  breadcrumbs: Object,
});

const clickStore = useClickStore();
const { state } = storeToRefs(clickStore);
const { closeOverlay, showSidebar } = clickStore;
const windowWidth = ref(window.innerWidth);
const direction = ref('ltr');

const overlay = computed(() => state.value.overlay);

watch(direction, newVal => {
  if (newVal === 'ltr') {
    document.documentElement.dir = 'ltr';
    document.body.classList.remove('rtl');
    document.body.classList.add('ltr');
  } else {
    document.documentElement.dir = 'rtl';
    document.body.classList.remove('ltr');
    document.body.classList.add('rtl');
  }
});

onMounted(() => {
  window.addEventListener('resize', handleWindowWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleWindowWidth);
});

function toggleDirection() {
  direction.value = direction.value === 'ltr' ? 'rtl' : 'ltr';
}

function handleWindowWidth() {
  windowWidth.value = window.innerWidth;
  if (windowWidth.value < 991) {
    closeOverlay();
  } else {
    showSidebar();
  }
}
</script>

<style></style>
